export * from './iconFontAwesomeHolidaysHeart';
export * from './iconFontAwesomeHolidaysMugHot';
export * from './iconFontAwesomeHolidaysGift';
export * from './iconFontAwesomeHolidaysCookieBite';
export * from './iconFontAwesomeHolidaysSnowman';
export * from './iconFontAwesomeHolidaysSleigh';
export * from './iconFontAwesomeHolidaysMenorah';
export * from './iconFontAwesomeHolidaysHollyBerry';
export * from './iconFontAwesomeHolidaysGifts';
export * from './iconFontAwesomeHolidaysFaceKissWinkHeart';
export * from './iconFontAwesomeHolidaysFaceGrinHearts';
export * from './iconFontAwesomeHolidaysChampagneGlasses';
export * from './iconFontAwesomeHolidaysCarrot';
export * from './iconFontAwesomeHolidaysCandyCane';
